<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import Alert from '../../components/Atoms/Alert.vue'
import FormSwitch from '../../components/Atoms/FormSwitch.vue'

const store = useStore()

const addonSubscriptions = computed(() => store.getters['User/addonSubscriptions'])
const userOverageBypass = computed(() => store.getters['User/overageBypass'])
const overageBypass = computed(() => {
	const liveSubscription = addonSubscriptions.value?.find(sub => sub.category === 'live')
	let overage = liveSubscription?.package?.definition?.exemptAutoDisable || false
	if (_.isBoolean(userOverageBypass.value)) {
		overage = userOverageBypass.value
	}
	return overage
})

onMounted(async () => {
	await store.dispatch('User/loadUser')
})
</script>
<template>
	<div class="lg:w-1/2">
		<Alert class="mb-6">
			<p><span class="text-white underline cursor-pointer" onclick="Intercom('show')">Contact us</span> to
				enable or disable overage
				settings.</p>
		</Alert>
		<div class="flex items-center">
			<h3 class="text-xl">Overage Enabled</h3>
			<FormSwitch v-model="overageBypass" class="ml-auto" disabled></FormSwitch>
		</div>
		<hr class="my-3">
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>